export default {
  content: {
    base: {
      color: 'uswitch-navy'
    }
  }
};